import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "danger" | "link";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  loading = false,
  disabled,
  children,
  ...rest
}: ButtonProps): JSX.Element {
  const isDisabled: boolean = disabled === true || loading;
  return (
    <button
      type="button"
      className={`button button--${variant}`}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="button__spinner" aria-hidden="true" /> : null}
      <span className="button__label">{children}</span>
    </button>
  );
}
